import { render, staticRenderFns } from "./accountingGeneralGivenConfig.vue?vue&type=template&id=599b8cda&"
import script from "./accountingGeneralGivenConfig.vue?vue&type=script&lang=js&"
export * from "./accountingGeneralGivenConfig.vue?vue&type=script&lang=js&"
import style0 from "./accountingGeneralGivenConfig.vue?vue&type=style&index=0&id=599b8cda&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports